module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "titlepage",
      "id": "bk"
    }
  }, [_c('h1', {
    staticClass: "bk"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "iii",
      "id": "piii",
      "role": "doc-pagebreak"
    }
  }), _vm._v("A Union Like Ours")]), _vm._v(" "), _c('h1', {
    staticClass: "bk1"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "piii"
    }
  }), _vm._v("The Love Story of F. O. Matthiessen and Russell Cheney")]), _vm._v(" "), _c('p', {
    staticClass: "bkau"
  }, [_vm._v("Scott Bane")]), _vm._v(" "), _c('p', {
    staticClass: "bkpub"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "piii"
    }
  }), _vm._v("Bright Leaf")]), _vm._v(" "), _c('p', {
    staticClass: "pcust1"
  }, [_vm._v("BOOKS THAT ILLUMINATE")]), _vm._v(" "), _c('p', {
    staticClass: "bkpub1"
  }, [_vm._v("Amherst and Boston")]), _vm._v(" "), _c('p', {
    staticClass: "pcust2"
  }, [_vm._v("An imprint of University of Massachusetts Press")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05d00bfc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uma_Bane0004.vue
// module id = 66
// module chunks = 0